import Identification from "../../entities/identification";

/**
 * Identification actions
 *
 * Call order:
 *
 * IDENTIFICATION_SAVE_QUEUE:	adds the item to the save queue
 * --> IDENTIFICATION_SAVE:	modifies the state
 * --> IDENTIFICATION_SAVE_SUCCESS: if all went well
 * --> IDENTIFICATION_SAVE_FAILURE:	if either the queue or local save failed
 *
 * Note that the only way to fail IDENTIFICATION_SAVE_QUEUE is during the call to IDENTIFICATION_SAVE,
 * as adding an item to the queue should never fail.
 */

export const IDENTIFICATION_FETCH_ONE_QUEUE: any = 'IDENTIFICATION_FETCH_ONE_QUEUE';
export const IDENTIFICATION_FETCH_SUCCESS: any = 'IDENTIFICATION_FETCH_SUCCESS';
export const IDENTIFICATION_FETCH_FAILURE: any = 'IDENTIFICATION_FETCH_FAILURE';
export const IDENTIFICATION_FETCH_ONE_SUCCESS: any = 'IDENTIFICATION_FETCH_ONE_SUCCESS';
export const IDENTIFICATION_FETCH_ONE_FAILURE: any = 'IDENTIFICATION_FETCH_ONE_FAILURE';

export const IDENTIFICATION_SAVE: any = 'IDENTIFICATION_SAVE';
export const IDENTIFICATION_SAVE_QUEUE: any = 'IDENTIFICATION_SAVE_QUEUE';
export const IDENTIFICATION_SAVE_SUCCESS: any = 'IDENTIFICATION_SAVE_SUCCESS';
export const IDENTIFICATION_SAVE_FAILURE: any = 'IDENTIFICATION_SAVE_FAILURE';

export const IDENTIFICATION_SAVE_MANY: any = 'IDENTIFICATION_SAVE_MANY';
export const IDENTIFICATION_SAVE_MANY_QUEUE: any = 'IDENTIFICATION_SAVE_MANY_QUEUE';
export const IDENTIFICATION_SAVE_MANY_SUCCESS: any = 'IDENTIFICATION_SAVE_MANY_SUCCESS';
export const IDENTIFICATION_SAVE_MANY_FAILURE: any = 'IDENTIFICATION_SAVE_MANY_FAILURE';

export const IDENTIFICATION_REMOVE: any = 'IDENTIFICATION_REMOVE';
export const IDENTIFICATION_REMOVE_QUEUE: any = 'IDENTIFICATION_REMOVE_QUEUE';
export const IDENTIFICATION_REMOVE_SUCCESS: any = 'IDENTIFICATION_REMOVE_SUCCESS';
export const IDENTIFICATION_REMOVE_FAILURE: any = 'IDENTIFICATION_REMOVE_FAILURE';

export const IDENTIFICATION_RESTORE: any = 'IDENTIFICATION_RESTORE';
export const IDENTIFICATION_RESTORE_QUEUE: any = 'IDENTIFICATION_RESTORE_QUEUE';
export const IDENTIFICATION_RESTORE_SUCCESS: any = 'IDENTIFICATION_RESTORE_SUCCESS';
export const IDENTIFICATION_RESTORE_FAILURE: any = 'IDENTIFICATION_RESTORE_FAILURE';

export const IDENTIFICATION_RESTORE_MANY: any = 'IDENTIFICATION_RESTORE_MANY';
export const IDENTIFICATION_REMOVE_MANY: any = 'IDENTIFICATION_REMOVE_MANY';

/* Fetch actions */
export const fetchIdentificationSuccess = (identifications: Identification[], partial: boolean, lastFetch: number) => ({type: IDENTIFICATION_FETCH_SUCCESS, identifications, partial, lastFetch});
export const fetchIdentificationFailure = (err: any) => {
		console.error('IdentificationAction: fetchIdentificationFailure', err);
		return {type: IDENTIFICATION_FETCH_FAILURE, err};
};
export const fetchOneIdentificationQueue = (identificationId: string) => ({type: IDENTIFICATION_FETCH_ONE_QUEUE, identificationId});
export const fetchOneIdentificationSuccess = (identification: Identification) => ({type: IDENTIFICATION_FETCH_ONE_SUCCESS, identification});
export const fetchOneIdentificationFailure = (id: string, err: any) => {
		console.error('IdentificationAction: fetchOneIdentificationFailure', err);
		return {type: IDENTIFICATION_FETCH_ONE_FAILURE, id, err};
};

/* Save actions */
export const saveIdentification = (identification: Identification) => {
    // console.debug('⮂ IDENTIFICATION_SAVE action', identification?.id);
    return {type: IDENTIFICATION_SAVE, identification};
}
export const saveIdentificationQueue = (identification: Identification, onQueued?: (saved: boolean) => void) => {
    // console.debug('⮂ IDENTIFICATION_SAVE_QUEUE action', identification?.id);
    return {type: IDENTIFICATION_SAVE_QUEUE, identification, onQueued};
}
export const saveIdentificationSuccess = (identification: Identification) => {
    // console.debug('⮂ IDENTIFICATION_SAVE_SUCCESS action', identification?.id);
    return {type: IDENTIFICATION_SAVE_SUCCESS, identification};
}
export const saveIdentificationFailure = (identification: Identification, status: number, message: string) => {
    console.warn(`⮂ IDENTIFICATION_SAVE_FAILURE error saving identification: HTTP ${status}: ${message}`, identification?.id);
    return {type: IDENTIFICATION_SAVE_FAILURE, identification, status, message};
};

/* SaveMany actions */
export const saveManyIdentifications = (identifications: Identification[]) => {
    // console.debug('⮂ IDENTIFICATION_SAVE_MANY action', identifications?.map(identification => identification?.id).join(','));
    return {type: IDENTIFICATION_SAVE_MANY, identifications};
}
export const saveManyIdentificationsQueue = (identifications: Identification[], onQueued?: (saved: boolean) => void) => {
    // console.debug('⮂ IDENTIFICATION_SAVE_MANY_QUEUE action', identifications?.map(identification => identification.id).join(','));
    return {type: IDENTIFICATION_SAVE_MANY_QUEUE, identifications, onQueued};
}

export const saveManyIdentificationsSuccess = (identifications: Identification[]) => {
    // console.debug('⮂ IDENTIFICATION_SAVE_MANY_SUCCESS action', identifications?.map(identification => identification.id).join(','));
    return {type: IDENTIFICATION_SAVE_MANY_SUCCESS, identifications};
}
export const saveManyIdentificationsFailure = (identifications: Identification[], status: number, message: string) => {
		console.warn(`⮂ SAVE_MANY_IDENTIFICATIONS_FAILURE Error saving identifications: HTTP ${status}: ${message}`, identifications?.map(identification => identification.id).join(','));
		return {type: IDENTIFICATION_SAVE_MANY_FAILURE, identifications, status, message};
};

/* Remove actions */
export const removeIdentification = (identification: Identification) => ({ type: IDENTIFICATION_REMOVE, identification });
export const removeIdentificationQueue = (identification: Identification) => ({ type: IDENTIFICATION_REMOVE_QUEUE, identification });
export const removeIdentificationSuccess = (identification: Identification) => ({ type: IDENTIFICATION_REMOVE_SUCCESS, identification });
export const removeIdentificationFailure = (identification: Identification, status: number, message: string) => {
	console.error(`Redux: removeIdentificationFailure Error removing identification: HTTP ${status}: ${message}`);
	return ({ type: IDENTIFICATION_REMOVE_FAILURE, identification, status, message });
};

/* Restore actions */
export const restoreIdentification = (identification: Identification) => ({ type: IDENTIFICATION_RESTORE, identification });
export const restoreIdentificationQueue = (identification: Identification) => ({ type: IDENTIFICATION_RESTORE_QUEUE, identification });
export const restoreIdentificationSuccess = (identification: Identification) => ({ type: IDENTIFICATION_RESTORE_SUCCESS, identification });
export const restoreIdentificationFailure = (identification: Identification, status: number, message: string) => {
	console.error(`Redux: restoreIdentificationFailure Error restoring identification: HTTP ${status}: ${message}`);
	return ({ type: IDENTIFICATION_RESTORE_FAILURE, identification, status, message });
};

/* RestoreMany actions */
export const restoreManyIdentifications = (identifications: Identification[]) => ({ type: IDENTIFICATION_RESTORE_MANY, identifications });

/* RemoveMany actions */
export const removeManyIdentifications = (identifications: Identification[]) => ({ type: IDENTIFICATION_REMOVE_MANY, identifications });